import React, { useState, useEffect } from 'react';
import { IonPage, IonRow, IonCol } from '@ionic/react';
import './ManageUser.page.scss';
import { ASC_DIRECTION } from '../../../utils/constants';
import IonUser from '../../components/Manage/IonUser';
import { ManageUserEmpty } from './ManageUserEmpty.page';
import { isEntitled, R2Configuration } from '../../../utils/common';
import { ToastMessage } from '../../../utils/ToastMessage';
import { ManageUserHeader } from './ManageUserHeader';
import { setScreenName } from '../../../utils/Analytics';
import { normalizeInput } from '../../../pages/Manage/ManageUser/ManageUserUtil';
import { MyLoad } from 'app/models/myLoad/myLoad';
import { FetchFromManageUserConfig, FetchFromMyLoadConfig } from 'app/utils/MyLoads.util';

const ManageUserPage: React.FC<any> = props => {
  const {
    users,
    isNetworkAvailable,
    showNetworkAlert,
    setFilter,
    filters
  } = props;
  const options = [
    { value: 'carrierAny', name: 'Any' },
    { value: 'carrierDriver', name: 'Driver' },
    { value: 'carrierDispatcher', name: 'Dispatcher' },
    { value: 'carrierAdmin', name: 'Admin' }
  ];
  const [usersList, setUsersList] = useState(users);
  const [isSearch, setIsSearch] = useState(false);
  const [pageIndex,setPageIndex] = useState<number>(0);
  const manageUsersMaxPageSize = FetchFromManageUserConfig("PageSize");
  const [showLoadId, setShowLoadId] = useState<any>("");

  const dropdown = {
    options,
    data: users,
    filterParam: 'roles',
    setFilter,
    direction: filters.direction
  };
  setScreenName("screen_manage_user");

  const addPage = () => {
    if (R2Configuration.details.getR2FeatureEnable()) {

      ToastMessage.show();
      return;
    }
    if (isNetworkAvailable) {
      props.history.push({
        pathname: '/app/userProfile/add', state: {
          addMode: true
        }
      })
    } else {
      showNetworkAlert();
    }
  };

  const filterData = () => {
    const { filterParam } = dropdown;
    const { selected, direction } = filters;
    const selectedOptions = selected.filter((type: any) => type.selected);
    if (selectedOptions.length === 0 || selectedOptions[0].name === 'Any') {
      return [...users].sort((user1: any, user2: any) => {
        if (
          user1 &&
          user1.updatedTimeStamp &&
          user2 &&
          user2.updatedTimeStamp
        ) {
          return new Date(user1.updatedTimeStamp).getTime() >
            new Date(user2 && user2.updatedTimeStamp).getTime()
            ? direction === ASC_DIRECTION
              ? 1
              : -1
            : direction === ASC_DIRECTION
              ? -1
              : 1;
        }
        return direction === ASC_DIRECTION ? -1 : 1;
      });
    }
    const list = users.filter((item: any) => {
      return (
        selectedOptions.filter(
          (type: any) =>
            item[filterParam].findIndex(
              (value: any) => value === type.value
            ) !== -1
        ).length > 0
      );
    });
    return direction === 'asc' ? list.reverse() : list;
  };

  const searchData = (name: string) => {
    setShowLoadId("")
    setIsSearch(true);
    if (name === '') {
      setUsersList(users);
      return;
    }
    const list = name.toString().split(',').map(i => i.trim());
    const newUsersList = users.filter((item: any) => list.find(val => {
      return `${item.firstName}${item.lastName}${item.mobileNumber}`.toLowerCase().includes(val.toLowerCase())
    }))
    setUsersList(newUsersList)
  }

  const filterDataa = (filterOptions: any) => {
    if (filterOptions.length === 0 || (filterOptions.length === 1 && filterOptions.find((item: any) => item === "carrierAny"))) {
      setUsersList(users);
      return;
    }
    const list = users.filter((item: any) => {
      return item.roles.find((role: any) => {
        return filterOptions.find((option: any) => option === role)
      })
    })
    setUsersList(list);
  }

  useEffect(() => {
    const data = filterData().map((user: any) => ({
      ...user,
      defaultMobileNumber: user.mobileNumber,
      mobileNumber: user.mobileNumber
    }));
    !isSearch && setUsersList(data);
  }, [users]);

  const getPaginatedLoads = (page?: number,SelectedDriver?: any) => {
    const _model: MyLoad = new MyLoad(); 
   
    if (page === 0 || page) setPageIndex(page)
    _model.driverId = SelectedDriver;
    _model.pagination = {
      pageSize: manageUsersMaxPageSize,
      pageIndex: (page === 0 || page) ? page : pageIndex,
    }
    props.fetchShipmentsForDriverInManageUser(_model.getMyDriverShipments(), false); 
  };

  return (
    <IonPage className="manageUserPage">
      <ManageUserHeader history={props.history} addPage={addPage} filterDataa={(options: any) => filterDataa(options)}
        searchData={(name: string) => searchData(name)}
      />
      <IonRow>
        <IonCol className="manageUserCol">
          {usersList.map((user: any, index: number) => (
            <IonUser
              key={user?.upn + index}
              user={user}
              loads={props?.loads}
              {...props}
              paginatedLoads={getPaginatedLoads}
              page={pageIndex}
              showLoads={showLoadId === index}
              setShowLoads={(status: boolean) =>
                setShowLoadId(status ? index : "")
              }
              setPageIndex={(defaultpageIndex : number) => setPageIndex(defaultpageIndex)}
            />
          ))}
          {usersList.length > 0 ? (
            <div className="end-of-list">End of list</div>
          ) : (
              <ManageUserEmpty
                message={isSearch}
                addPage={addPage}
                constantButton="Add"
              />
            )}
        </IonCol>
      </IonRow>

    </IonPage>
  )
};
export default React.memo(ManageUserPage);
